// components/DriveBrowser.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from 'rehype-raw';

const FileBrowser = ({ folderBase, bag }) => {
  const [items, setItems] = useState([]);
  const [markdownContents, setMarkdownContents] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname.replace("/" + bag, "").replace(/^\/+/, "");
  const encodedSegments = rawPath ? rawPath.split("/") : [];

   const path = location.pathname.split("/").filter(Boolean);

  const encodeUrlSafe = (text) => {
    return btoa(text)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

 const decodeUrlSafe = (encoded) => {
    let str = encoded.replace(/-/g, "+").replace(/_/g, "/");
    while (str.length % 4) {
      str += "=";
    }
    return atob(str);
  };

  const relativePath = encodedSegments.length
    ? encodedSegments.map(decodeUrlSafe).join("/")
    : "";

  const folderPath = relativePath || "";



  // ambil list file/folder
  const fetchList = async (relativePath = "") => {
    let path = folderBase;
    if (relativePath) {
      //path += "/" + decodeURIComponent(relativePath);
      
      const relativePath =  encodedSegments.length
        ? encodedSegments.map(decodeUrlSafe).join("/")
      : "";
      path += "/" + relativePath;
    }
   
    try {
      const API_BASE = process.env.REACT_APP_API_BASE;
      const response = await fetch(
        `${API_BASE}/list.php?path=${encodeURIComponent(path)}`
      );
     
      if (!response.ok) throw new Error("Gagal fetch list.json");
       
      const data = await response.json();
     
      let files = data || [];
     
      // sort: angka dulu, lalu alfabet
      files.sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return a.name.localeCompare(b.name, "id", { numeric: true });
      });

      setItems(files);

      // preload markdown
      files
        .filter((f) => f.type === "md")
        .forEach((f) => fetchMarkdownFile(path, f.name, f.id));
    } catch (err) {
      console.error("Error fetch list.json:", err);
      setItems([]);
    }
  };

  const fetchMarkdownFile = async (folderPath, fileName, fileId) => {
    try {
      const res = await fetch(`${folderPath}/${fileName}`);
      const text = await res.text();
      setMarkdownContents((prev) => ({ ...prev, [fileId]: text }));
    } catch (err) {
      console.error("Error fetching markdown", err);
    }
  };

  const handleBack = () => {
    if (!encodedSegments.length) return;

    const prevEncoded = [...encodedSegments];
    prevEncoded.pop();

    if (prevEncoded.length) navigate(`/${bag}/${prevEncoded.join("/")}`);
    else navigate("/" + bag);
  };

  const getNameWithoutExt = (filename) =>
    filename.replace(/\.[^/.]+$/, "");

  useEffect(() => {
    fetchList(relativePath);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [relativePath]);

  return (
    <div>
      <nav className="flex items-center space-x-2 text-sm text-gray-600" style={{marginBottom: "12px"}}>
        {path.map((segment, index) => {
          // buat path sampai ke index ini
          const fullPath = "/" + path.slice(0, index + 1).join("/");

          return (
            <span key={index} className="flex items-center">
              <Link
                to={fullPath}
                className="hover:underline text-blue-600 x-small" style={{fontSize:"small"}}
              >
                {index === 0 ? segment.toUpperCase() : decodeUrlSafe(segment)}
              </Link>
              {index < path.length - 1 && <span className="mx-1">/</span>}
            </span>
          );
        })}
      </nav>
      <article className="widget widget-download" style={{ textAlign: "left" }}>
        {/* 🔙 Tombol kembali */}
        {folderPath && (
          <button
            onClick={handleBack}
            style={{
              marginBottom: "12px",
              padding: "6px 12px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              background: "#f5f5f5",
              cursor: "pointer",
              color: "#333",
            }}
          >
            ⬅ Kembali
          </button>
        )}

        <ul className="download">
          {items.map((item) => (
            <li key={item.id}>
              {item.type === "folder" ? (
                <Link
                  to={`/${bag}/${
                    encodedSegments.length
                      ? [...encodedSegments, encodeUrlSafe(item.name)].join("/")
                      : encodeUrlSafe(item.name)
                  }`}
                  className="item-link"
                  style={{ display: "flex", alignItems: "center", textDecoration: "none", color:"inherit" }}
                >
                  <i className="fa fa-folder" style={{ marginRight: "8px" }}></i>
                  {item.name}
                </Link>
              ) : item.type === "pdf" ? (
                <div>
                  <p>
                    <i className="fa fa-file-pdf-o"></i>{" "}
                    {getNameWithoutExt(item.name)}
                  </p>
                  <iframe
                    src={`${folderBase}/${folderPath}/${item.name}`}
                    width="100%"
                    height="600"
                    style={{ border: "none", marginTop: "8px" }}
                    title={item.name}
                  ></iframe>
                </div>
              ) : item.type === "image" ? (
                <div>
                  <p>
                    <i className="fa fa-file-image-o"></i>{" "}
                    {getNameWithoutExt(item.name)}
                  </p>
                  <img
                    src={`${folderBase}/${folderPath}/${item.name}`}
                    alt={item.name}
                    style={{
                      maxWidth: "100%",
                      marginTop: "8px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ) : item.name.endsWith(".md") ? (
                <div className="markdown-body">
                  <p>
                    <i className="fa fa-file-text-o"></i>{" "}
                    <b>{getNameWithoutExt(item.name)}</b>
                  </p>
                  <ReactMarkdown remarkPlugins={[remarkGfm]}  rehypePlugins={[rehypeRaw]} >
                    {markdownContents[item.id] || "Loading..."}
                  </ReactMarkdown>
                </div> 
              ) : (
                <a
                  href={`${folderBase}/${folderPath}/${item.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-file-o"></i> {item.name}
                </a>
              )}
            </li>
          ))}
        </ul>
      </article>
    </div>
  );
};

export default FileBrowser;
